const schema = () => ({
  type: 'object',
  required: ['firstname', 'lastname', 'cellphone'],
  properties: {
    firstname: {
      type: 'string',
      title: 'نام',
      default: '',
    },
    lastname: {
      type: 'string',
      title: 'نام خانوادگی',
      default: '',
    },
    cellphone: {
      type: 'string',
      title: 'شماره تلفن همراه',
      minLength: 10,
      pattern: '^09[0-9]{9}$',
    },
    gender: {
      type: 'number',
      title: 'جنسیت',
      oneOf: [
        { const: 1, title: 'مرد' },
        { const: 0, title: 'زن' },
      ],
      default: 1,
    },
    user_category_id: {
      type: 'string',
      title: 'گروه',
    },
  },
});

export default schema;
